// Overdrawn Cash: the routes and the sidebar rows of `wealth.ops.overdrawn-cash` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.overdrawn-cash',
    routes: [
        {
            frontend: 'ops',
            path: 'cash-management',
            lazy: () => import('@/pages/ops/cash-management/page'),
        },
        {
            frontend: 'ops',
            path: 'cash/overdrawn',
            lazy: () => import('@/pages/ops/cash/overdrawn/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'overdrawn-cash',
            label: 'Overdrawn Cash',
            href: '/ops/cash/overdrawn',
            icon: 'AlertTriangle',
            group: 'cash',
            order: 310,
        },
        // Retired: its purpose is the overdrawn-account exception report, which
        // the Overdrawn Cash row below already owns. Two doors onto one job made
        // the operator choose between them for no gain.
        {
            frontend: 'ops',
            key: 'cash-management',
            label: 'Cash Management',
            href: '/ops/cash-management',
            icon: 'Wallet',
            group: 'cash',
            order: 2060,
            hidden: true,
        },
    ],
});
